import React, { useContext } from 'react';

import { SamlApi } from '../apis';
import { api } from '../api';

const SamlApiContext = React.createContext(new SamlApi(api));

export const SamlApiProvider = SamlApiContext.Provider;
export const useSamlApi = (): SamlApi => useContext(SamlApiContext);
